var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}arrow_circle-24`,"viewBox":"0 0 24 24"}},[_c('circle',{staticClass:"base",attrs:{"cx":"12","cy":"12","r":"12"}}),_c('path',{staticClass:"sign arrow",attrs:{"d":"M11.0002 12.2072V8H13.0002V12.2071L14.6038 10.6035L16.018 12.0178L12.0002 16.0355L7.98242 12.0178L9.39664 10.6035L11.0002 12.2072Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }